import { showErrorAlert, showSuccessAlert } from 'actions';
import {
  fetchIntegrationSettings,
  fetchIntegrationSettingsFailure,
  fetchIntegrationSettingsRequest,
  fetchIntegrationSettingsSuccess,
  upsertIntegrationSettings,
  upsertIntegrationSettingsFailure,
  upsertIntegrationSettingsRequest,
  upsertIntegrationSettingSuccess,
} from 'actions/integrationSettings';
import { apiClient as LitLingoClient } from 'client';
import { call, put, takeLatest } from 'redux-saga/effects';
import { API, SagaReturn } from 'types';

function* fetchIntegrationSettingsSaga(): SagaReturn {
  yield put(fetchIntegrationSettingsRequest());

  const response = (yield call([
    LitLingoClient.resources.integrationSettings.extras,
    'current',
  ])) as API.Response<API.IntegrationSettings.Retrieve>;

  if (response.error != null) {
    yield put(fetchIntegrationSettingsFailure(response.error));
  } else {
    yield put(fetchIntegrationSettingsSuccess(response.data));
  }
}

function* upsertIntegrationSettingSaga(
  action: ReturnType<typeof upsertIntegrationSettings>
): SagaReturn {
  const { payload } = action;

  yield put(upsertIntegrationSettingsRequest());

  const response = (yield call([LitLingoClient.resources.integrationSettings, 'upsert'], {
    data: payload,
  })) as API.Response<API.IntegrationSettings.Upsert>;

  if (response.error != null) {
    yield put(upsertIntegrationSettingsFailure(response.error));

    yield put(
      showErrorAlert(
        "Something went wrong and the integration settings can't be saved at this time"
      )
    );
  } else {
    yield put(upsertIntegrationSettingSuccess(response.data));
    yield put(showSuccessAlert(`Settings have been saved successfully`));
  }
}

function* integrationSettingsSaga(): SagaReturn {
  yield takeLatest(fetchIntegrationSettings.toString(), fetchIntegrationSettingsSaga);
  yield takeLatest(upsertIntegrationSettings.toString(), upsertIntegrationSettingSaga);
}

export default integrationSettingsSaga;
